/**
 * Adds the product's Trustpilot rating to its ProductGroup JSON-LD, as the old
 * theme's section-trustpilot-product-schema did with microdata. The ratings live
 * in Trustpilot, not Shopify, so this runs in the browser; Google renders the
 * page and reads the updated JSON-LD. One request, after the load event.
 */
const API = "https://api.trustpilot.com/v1/product-reviews/business-units";

async function addRating(script) {
  const { tpBusinessUnit: unit, tpKey: key, tpSkus: skus } = script.dataset;
  const sku = (skus || "")
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean)
    .map(encodeURIComponent)
    .join(",");
  if (!unit || !key || !sku) return;

  const response = await fetch(`${API}/${unit}?sku=${sku}&apikey=${encodeURIComponent(key)}`);
  if (!response.ok) return;
  const summary = await response.json();

  const count = Number(summary?.numberOfReviews?.total);
  const average = Number(summary?.starsAverage);
  if (!(count > 0) || !(average > 0)) return;

  const data = JSON.parse(script.textContent);
  const group = (Array.isArray(data) ? data : [data]).find(
    (item) => item["@type"] === "ProductGroup",
  );
  if (!group) return;

  group.aggregateRating = {
    "@type": "AggregateRating",
    ratingValue: average,
    reviewCount: count,
    bestRating: 5,
    worstRating: 1,
  };
  script.textContent = JSON.stringify(data);
}

function run() {
  const script = document.querySelector('script[type="application/ld+json"][data-tp-skus]');
  if (script) addRating(script).catch(() => {});
}

if (document.readyState === "complete") run();
else window.addEventListener("load", run, { once: true });
